import axios from 'axios'
import swal from 'sweetalert2'

import { useLogout } from 'hooks/useAuthentication'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
})

/**
 * @param {string} text
 * @param {string} title
 * @param {string} type
 */
function onSuccess({ text, title = 'Operación exitosa!', type = 'success' }) {
  swal.fire({ title, text, type })
}

// add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    return {
      ...config,
      headers: {
        Authorization: `JWT ${window.localStorage.getItem('__atk__')}`,
        'Content-Type': 'application/json',
      },
    }
  },
  (err) => {
    return Promise.reject(err)
  },
)

// add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    const { config, data } = response
    if (['post', 'put', 'delete'].includes(config.method)) {
      return { data, onSuccess }
    }
    return response
  },
  ({response: { data, status }}) => {
    switch (status) {
      case 401:
        return useLogout()
      default:
        return Promise.reject(data)
    }
  },
)

export default axiosInstance
